import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Target, TrendingUp, ArrowRight, Zap } from 'lucide-react';
import { Card } from '../ui/Card';
import { AppState } from '../../types';
import { Button } from '../ui/Button';
interface FocusPanelProps {
  state: AppState;
  onStartFocusSession: () => void;
}
export function FocusPanel({
  state,
  onStartFocusSession
}: FocusPanelProps) {
  const totalReviewNeeded = Object.values(state.progress).reduce((sum, progress) => sum + progress.reviewNeededCount, 0);
  const hasReviewItems = totalReviewNeeded > 0;
  // Only render if there are items to review - "Smart" component
  if (!hasReviewItems) return null;
  return <AnimatePresence data-id="element-305">
      <motion.div initial={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      scale: 0.95
    }} className="mb-8" data-id="element-306">
        <Card className="relative overflow-hidden border-2 border-indigo-100 shadow-lg shadow-indigo-100/50 bg-white" data-id="element-307">
          {/* Subtle animated background gradient */}
          <motion.div className="absolute inset-0 bg-gradient-to-r from-indigo-50/50 via-purple-50/50 to-pink-50/50" animate={{
          backgroundPosition: ['0% 0%', '100% 100%']
        }} transition={{
          duration: 10,
          repeat: Infinity,
          repeatType: 'reverse'
        }} data-id="element-308" />

          <div className="relative p-4 md:p-5 flex flex-col md:flex-row items-center justify-between gap-4 md:gap-6" data-id="element-309">
            {/* Left side: Icon + Text */}
            <div className="flex items-center gap-4 w-full md:w-auto" data-id="element-310">
              <div className="relative flex-shrink-0" data-id="element-311">
                <motion.div animate={{
                rotate: [0, 10, -10, 0]
              }} transition={{
                duration: 4,
                repeat: Infinity,
                repeatDelay: 1
              }} className="w-14 h-14 bg-gradient-to-br from-indigo-600 to-purple-600 rounded-xl flex items-center justify-center shadow-md transform rotate-3" data-id="element-312">
                  <Target className="w-7 h-7 text-white" data-id="element-313" />
                </motion.div>
                <div className="absolute -top-2 -right-2 bg-rose-500 text-white w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold border-2 border-white shadow-sm" data-id="element-314">
                  {totalReviewNeeded}
                </div>
              </div>

              <div className="flex-1 text-left" data-id="element-315">
                <div className="flex items-center gap-2 mb-0.5" data-id="element-316">
                  <h3 className="font-bold text-slate-900 text-lg" data-id="element-317">
                    Superkracht Training
                  </h3>
                  <span className="bg-indigo-100 text-indigo-700 text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider flex items-center gap-1" data-id="element-318">
                    <Zap className="w-3 h-3" data-id="element-319" />
                    Nieuw
                  </span>
                </div>
                <p className="text-slate-600 text-sm font-medium" data-id="element-320">
                  {totalReviewNeeded}{' '}
                  {totalReviewNeeded === 1 ? 'doordenker wacht' : 'doordenkers wachten'}{' '}
                  op je!
                </p>
              </div>
            </div>

            {/* Right side: Action Button */}
            <div className="w-full md:w-auto flex-shrink-0" data-id="element-321">
              <Button onClick={onStartFocusSession} size="lg" variant="primary" className="w-full md:w-auto shadow-md shadow-indigo-200 hover:shadow-indigo-300 hover:-translate-y-0.5 transition-all" data-id="element-322">
                <TrendingUp className="w-4 h-4 mr-2" data-id="element-323" />
                Start Training
                <ArrowRight className="w-4 h-4 ml-2 opacity-80" data-id="element-324" />
              </Button>
            </div>
          </div>
        </Card>
      </motion.div>
    </AnimatePresence>;
}